import { useState } from 'react'
import Alert from '@/components/ui/Alert'
import Button from '@/components/ui/Button'

import ChangePasswordForm from './components/ChangePasswordForm'
import useTimeOutMessage from '@/utils/hooks/useTimeOutMessage'
import { useNavigate } from 'react-router-dom'

type ChangePasswordProps = {
    signInUrl?: string
}

export const ChangePasswordBase = ({
    signInUrl = '/sign-in',
}: ChangePasswordProps) => {
    const [resetComplete, setResetComplete] = useState(false)

    const [message, setMessage] = useTimeOutMessage()

    const navigate = useNavigate()

    const handleContinue = () => {
        navigate(signInUrl)
    }

    return (
        <div>
            <div className="flex justify-center lg:h-full p-6 dark:bg-gray-800">
                <div className="py-6 px-10 lg:flex flex-col flex-1 justify-between bg-white rounded-2xl items-center relative max-w-[520px] 2xl:max-w-[720px]">
                    <div className="mb-6">
                        {resetComplete ? (
                            <>
                                <h3 className="mb-1">Reset done</h3>
                                <p className="font-semibold heading-text">
                                    Your password has been successfully reset
                                </p>
                            </>
                        ) : (
                            <>
                                <div className="login-page-logo mt-8">
                                    <img className='mx-auto mb-4' src="/portal/img/logo/oasys-logo.png" />
                                </div>
                                <h5 className="mb-1 mt-4 text-center">Change Password</h5>
                                <p className="font-medium heading-text text-center">
                                To make your account secure, please create a new password to replace the temporary password you were given in the email invitation.
                                </p>
                            </>
                        )}
                    </div>
                    {message && (
                        <Alert showIcon className="mb-4" type="danger">
                            <span className="break-all">{message}</span>
                        </Alert>
                    )}
                    <ChangePasswordForm
                        resetComplete={resetComplete}
                        setMessage={setMessage}
                        setResetComplete={setResetComplete}
                    >
                        <Button
                            block
                            variant="solid"
                            type="button"
                            onClick={handleContinue}
                        >
                            Continue
                        </Button>
                    </ChangePasswordForm>
                    {/* <div className="mt-4 text-center">
                        <span>Have an account? </span>
                        <ActionLink
                            to={signInUrl}
                            className="heading-text font-bold"
                            themeColor={false}
                        >
                            Sign in
                        </ActionLink>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

const ChangePassword = () => {
    return <ChangePasswordBase />
}

export default ChangePassword